<main id="main" class="main">
  <div class="row paddingHeader">
    <div class="col-12 col-md-12 d-flex justify-content-between" style="background: #5d7c9b!important; font-size:14px">
      <h6 class="admintitle my-auto">
        Tiers&nbsp;&nbsp;
      </h6>
      <button class="addCustomer my-auto">+&nbsp;Add New</button>


    </div>
  </div>

  <div class="row">
    <div class="table-responsive">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_0"
        class="table text-nowrap">
        <thead>
          <tr>
            <!-- <th>S.no</th> -->
            <th>S.no</th>
            <th>Tier Name</th>
            <th>Description</th>
            <th>Time of Service</th>
            <th>Member Count</th>
            <th>Plans</th>
            <th>Link</th>
            <th>Wallet</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>All</td>
            <td>All Tiers</td>
            <td>Min:5 Years <br>Max:10 Years</td>
            <td class="tierMember">0</td>
            <td>Classic Bronze</td>
            <td class="tierMember">https://igbms.com &nbsp;<i class="fa fa-copy" style="font-size:14px"></i></td>
            <td class="tierMember">No</td>
            <td>Active</td>
            <td>
              <i class="fa fa-eye" style="font-size:14px;color:blue"></i>&nbsp;
              <i class="fa fa-pencil" style="font-size:14px;color:green"></i>&nbsp;
              <i class="fa fa-trash" style="font-size:14px;color:red"></i>&nbsp;
              <i class="fa fa-history" style="font-size:14px;color:blueviolet"></i>
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>Employee</td>
            <td>All General Configurations</td>
            <td>NA</td>
            <td class="tierMember">2</td>
            <td>Classic Silver</td>
            <td class="tierMember">https://igbms.com &nbsp;<i class="fa fa-copy" style="font-size:14px"></i></td>
            <td class="tierMember">No</td>
            <td>In Active</td>
            <td>
              <i class="fa fa-eye" style="font-size:14px;color:blue"></i>&nbsp;
              <i class="fa fa-pencil" style="font-size:14px;color:green"></i>&nbsp;
              <i class="fa fa-trash" style="font-size:14px;color:red"></i>&nbsp;
              <i class="fa fa-history" style="font-size:14px;color:blueviolet"></i>
            </td>
          </tr>
          <tr>
            <td>3</td>
            <td>Executive</td>
            <td>All Executive Configurations</td>
            <td>Min:2 Years <br>Max:5 Years</td>
            <td class="tierMember">2</td>
            <td>EAP 2.0</td>
            <td class="tierMember">https://igbms.com &nbsp;<i class="fa fa-copy" style="font-size:14px"></i></td>
            <td class="tierMember" id="tooltip">Yes
              <table class="tooltiptext ignoreTable">


                <tbody>
                  <tr class="ignoreTable">
                    <td>Wallet Amount: $1000</td>
                  </tr>
                  <tr class="ignoreTable">
                    <td>Wallet Type: Yes</td>
                  </tr>
                  <tr class="ignoreTable">
                    <td>Carry Forword: Yes</td>
                  </tr>
                  <tr class="ignoreTable">
                    <td>Allocated: Monthly</td>
                  </tr>
                  <tr class="ignoreTable">
                    <td>Industry Category:-</td>
                  </tr>
                  <tr class="ignoreTable">
                    <td>Advisor Fee:5%</td>
                  </tr>
                  <tr class="ignoreTable">
                    <td>Balance SetUp:Prorated</td>
                  </tr>
                  <tr class="ignoreTable">
                    <td>Coverage Percenatge:5%</td>
                  </tr>


                </tbody>
              </table>
            </td>
            <td>Active</td>
            <td>
              <i class="fa fa-eye" style="font-size:14px;color:blue"></i>&nbsp;
              <i class="fa fa-pencil" style="font-size:14px;color:green"></i>&nbsp;
              <i class="fa fa-trash" style="font-size:14px;color:red"></i>&nbsp;
              <i class="fa fa-history" style="font-size:14px;color:blueviolet"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</main>
